import { useSelector } from 'react-redux'
import {
  selectCorporateProfile,
  selectCustomerCorporationName,
  selectCustomerEmail,
  selectCustomerNMLS,
  selectCustomerPhone,
  selectCustomerPhotoUri,
  selectCustomerTitle,
  selectName,
  selectScheduleACallUri
} from '../../../store/selectors/customerProfile'
import { TeamCard } from './TeamCard'
import { useEffect } from 'react'

interface PrimaryTeamMemberProps {
  onLoadingChange?: (isLoading: boolean) => void
}

export const PrimaryTeamMemberCard = ({ onLoadingChange }: PrimaryTeamMemberProps) => {
  const customerName = useSelector(selectName)
  const email = useSelector(selectCustomerEmail)
  const photoUri = useSelector(selectCustomerPhotoUri)
  const nmls = useSelector(selectCustomerNMLS)
  const phone = useSelector(selectCustomerPhone)
  const title = useSelector(selectCustomerTitle)
  const corporateProfileName = useSelector(selectCustomerCorporationName)
  const corporateProfile = useSelector(selectCorporateProfile) || {}
  const corporatePhotoUri = corporateProfile.avatarUri || ''
  const scheduleACallUri = useSelector(selectScheduleACallUri)

  const isLoading = !customerName || !email || !phone || !title

  useEffect(() => {
    onLoadingChange?.(isLoading)
  }, [isLoading, onLoadingChange])

  if (isLoading) {
    return null
  }
  return (
    <TeamCard
      teamMemberName={customerName}
      corporatePhotoUri={corporatePhotoUri}
      scheduleACallUri={scheduleACallUri}
      email={email}
      photoUri={photoUri}
      isPrimary
      nmls={nmls}
      phone={phone}
      title={title}
      corporateProfileName={corporateProfileName}
    />
  )
}
